import _extends from "@babel/runtime/helpers/esm/extends";

/* eslint-disable import/order */
// This file has been generated using @svgr/cli.
// Run "yarn generate:icons" in order to generate the files for new icons.
import * as React from 'react';
import styled from 'styled-components';
import { size, color } from 'styled-system';

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.545 28.727v-9.314c1.446-.659 3.06-.989 4.849-.989 1.169 0 1.973.213 3.727.87 1.882.707 2.795.948 4.152.948 1.757 0 3.645-.432 5.662-1.29a3.03 3.03 0 0 0 1.815-2.377c.268-1.95.402-4.161.402-6.636 0-2.576-.145-4.584-.438-6.035a1.212 1.212 0 0 0-1.695-.86c-2.092.963-4.007 1.44-5.746 1.44-1.169 0-1.973-.212-3.727-.87-1.883-.706-2.795-.947-4.152-.947-1.392 0-2.696.184-3.912.554a3.03 3.03 0 0 0-2.149 2.9v22.606a.606.606 0 0 0 1.212 0Zm9.001-10.567c-1.883-.706-2.795-.948-4.152-.948-1.756 0-3.374.294-4.849.883V6.12c0-.8.524-1.507 1.29-1.74 1.098-.334 2.284-.501 3.559-.501 1.169 0 1.973.213 3.727.87 1.882.706 2.795.948 4.152.948 1.927 0 4.012-.52 6.253-1.553.274 1.358.413 3.293.413 5.795 0 2.422-.13 4.58-.39 6.471a1.818 1.818 0 0 1-1.089 1.426c-1.875.798-3.604 1.194-5.187 1.194-1.169 0-1.973-.213-3.727-.87Z",
    fill: "currentColor"
  }));
};

var SvgBanner = styled(SvgComponent).withConfig({
  displayName: "Banner__SvgBanner",
  componentId: "sc-1g03cw6-0"
})(["", " ", ""], size, color);
export default SvgBanner;